"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DisconnectCalendarIntegrationResponse () {
        return DisconnectCalendarIntegrationResponse;
    },
    get DisconnectVideoConferencingResponse () {
        return DisconnectVideoConferencingResponse;
    },
    get GetMeetingsIntegrationsAvailableProvidersResponse () {
        return GetMeetingsIntegrationsAvailableProvidersResponse;
    },
    get GetMeetingsIntegrationsSettingsResponse () {
        return GetMeetingsIntegrationsSettingsResponse;
    },
    get GetUserCalendarIntegrationStatusResponse () {
        return GetUserCalendarIntegrationStatusResponse;
    },
    get GetUserCalendarsResponse () {
        return GetUserCalendarsResponse;
    },
    get GetUserVideoConferencingStatusResponse () {
        return GetUserVideoConferencingStatusResponse;
    },
    get InitiateCalendarIntegrationOAuthFlowResponse () {
        return InitiateCalendarIntegrationOAuthFlowResponse;
    },
    get InitiateVideoConferencingOAuthFlowResponse () {
        return InitiateVideoConferencingOAuthFlowResponse;
    },
    get PatchMeetingsIntegrationsSettingsResponse () {
        return PatchMeetingsIntegrationsSettingsResponse;
    },
    get SaveSelectedCalendarResponse () {
        return SaveSelectedCalendarResponse;
    }
});
const _zod = require("zod");
const _base = require("./base");
const GetMeetingsIntegrationsSettingsResponse = _base.MeetingsIntegrationsSettingsSchema;
const PatchMeetingsIntegrationsSettingsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const InitiateCalendarIntegrationOAuthFlowResponse = _zod.z.object({
    authUrl: _zod.z.string()
});
const GetUserCalendarIntegrationStatusResponse = _zod.z.object({
    isConnected: _zod.z.boolean(),
    provider: _zod.z.enum([
        "google",
        "outlook"
    ]).nullable(),
    connectedAt: _zod.z.date().nullable(),
    selectedCalendarId: _zod.z.string().nullable(),
    tokenExpired: _zod.z.boolean()
});
const DisconnectCalendarIntegrationResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetUserCalendarsResponse = _zod.z.object({
    calendars: _zod.z.array(_zod.z.object({
        id: _zod.z.string(),
        name: _zod.z.string(),
        primary: _zod.z.boolean().optional()
    }))
});
const SaveSelectedCalendarResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const GetMeetingsIntegrationsAvailableProvidersResponse = _zod.z.object({
    providers: _zod.z.array(_zod.z.object({
        provider: _base.VideoConferencingProviderEnum,
        displayName: _zod.z.string()
    }))
});
const GetUserVideoConferencingStatusResponse = _zod.z.object({
    connections: _zod.z.array(_base.VideoConferencingConnectionSchema)
});
const InitiateVideoConferencingOAuthFlowResponse = _zod.z.object({
    authUrl: _zod.z.string()
});
const DisconnectVideoConferencingResponse = _zod.z.object({
    success: _zod.z.boolean()
});
